import React, { useEffect, useRef, useState } from 'react'
import AutoComplete from '../../Inputs/AutoComplete/AutoComplete'
import Popup from '../../Popup/Popup'
import Button from '../../Button/Button'
import Row from '../../Row/Row'
import Column from '../../Column/Column'
function Search({
    search,
    isCollapsed,
    searchResultData,
    renderSearchResults,
    setSearchResultQuery,
    setSearchResultData,
}) {
    const ref = useRef(null)
    const contentRef = useRef(null)
    const [showPopup, setShowPopup] = useState(false)

    const handleClickOutside = (e) => {
        if (contentRef.current) {
            if (contentRef.current.contains(e.target)) {
                return
            }
        }
        setShowPopup(false)
    }
    useEffect(() => {
        if (!showPopup) {
            document.removeEventListener('click', handleClickOutside)
            setSearchResultQuery('')
            setSearchResultData(null)
        }
        if (showPopup) {
            document.addEventListener('click', handleClickOutside)
        }
    }, [showPopup])

    const searchInput = (
        <AutoComplete
            suppressPopup
            dataSource={search.dataSource}
            name={'globalSearch'}
            placeholder={'Search'}
            valueField={'VALUE'}
            textField={'TEXT'}
            noLabel
            onInternalChange={(val) => {
                setSearchResultQuery(val)
                if (val === '') {
                    setSearchResultData(null)
                }
            }}
            onClear={() => {
                setSearchResultData(null)
            }}
        />
    )

    if (search && isCollapsed) {
        return (
            <div className={'r-side-navigation-Search-container'}>
                <Button
                    icon={'search'}
                    ref={ref}
                    onClick={(e) => {
                        e.stopPropagation()
                        setShowPopup(true)
                    }}
                />
                <Popup
                    anchor={ref}
                    show={showPopup}
                    pos={'right'}
                    width={'500px'}
                    maxHeight={null}
                    height={'calc(100vh - 200px)'}
                >
                    <div ref={contentRef} className={'r-side-navigation-Search-results'}>
                        <Row>
                            <Column>{searchInput}</Column>
                            <Column>{searchResultData ? renderSearchResults() : ''}</Column>
                        </Row>
                    </div>
                </Popup>
            </div>
        )
    }
    return searchInput
}

export default Search
